import { useTheme } from '@emotion/react'

import Sidebar from '../Sidebar'

interface Props {
  children: React.ReactChild | React.ReactChild[]
}

const scrollProps = {
  smooth: true,
  activeClass: 'active',
  spy: true,
  duration: 300,
  offset: -100,
}

const contentStyle = {
  '& h1': {
    fontSize: {
      base: '--fontSizes-3_25xl',
      md: '--fontSizes-5xl',
    },
    fontWeight: 'medium',
    marginBottom: '16px',
  },

  '& h2': {
    fontSize: {
      base: '--fontSizes-2xl',
      md: '--fontSizes-3_25xl',
    },
    fontWeight: 'medium',
    marginBottom: '--space-2',
  },

  '& h3': {
    fontSize: {
      base: '20px',
      md: '--fontSizes-2xl',
    },
    fontWeight: 'medium',
    marginBottom: '--space-2',
  },

  '& li': {
    marginBottom: '--space-1',
  },

  '& p': {
    marginBottom: '--space-6',
  },

  '& li, & p': {
    fontSize: '16px',
    fontWeight: 'light',
    fontFamily: 'arial, san-serif',
  },

  '& strong': {
    color: 'inherit',
    fontWeight: 'bold',
  },

  '& a': {
    fontWeight: 'medium',
    color: '--colors-primary-500',
    textDecoration: 'underline',
  },

  '& a:hover': {
    color: '--colors-primary-600',
  },

  '& hr': {
    borderColor: '--colors-300',
  },

  '& ul, & ol': {
    display: 'grid',
    gridAutoRows: 'max-content',
    gap: '--space-2',
    marginBottom: '--space-6',
    paddingLeft: '--space-6',
    '& li': {
      display: 'flex',

      strong: {
        display: 'contents',
      },

      '&:not(:last-of-type)': {
        marginBottom: '--space-2',
      },
    },
  },

  '& ul': {
    '& li': {
      '&::before': {
        content: "''",
        minWidth: '--space-1',
        height: '--space-1',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '12px',
        backgroundColor: '--colors-900',
        marginTop: '0.6em',
      },
    },
  },

  '& ol': {
    '& li': {
      counterIncrement: 'item',
      '&::before': {
        content: 'counter(item) ". "',
        display: 'inline-block',
        minWidth: '30px',
      },
    },
  },
}

export default function TermsNPrivacyProvider({
  children,
}: Props): React.ReactElement {
  const theme = useTheme()

  return (
    <div
      className="TermNPrivacyContainer"
      css={theme.mq({
        display: 'grid',
        maxWidth: '1113px',
        margin: '0 auto',
        gridTemplateColumns: {
          base: '1fr',
          md: '280px 1fr',
        },
        marginTop: {
          base: '60px',
          md: '72px',
        },
        paddingTop: '--space-10',
        marginBottom: '--space-6',
        paddingLeft: {
          base: '--space-6',
          md: 0,
        },
        paddingright: {
          base: '--space-6',
          md: 0,
        },
      })}
    >
      <Sidebar scrollProps={scrollProps} bottomBoundary="#end-content" />
      <main
        css={theme.mq({
          padding: {
            base: '0',
            md: '62px 0 127px 122px',
          },
          borderLeft: {
            base: 'none',
            md: '1px solid',
          },
          borderColor: {
            base: 'transparent',
            md: '--colors-gray-200',
          },
          ...contentStyle,
        })}
      >
        {children}
      </main>
    </div>
  )
}
